import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { loadState, saveState } from '../utils/localStorage';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const WeightView = () => {
  const { t } = useTranslation();
  const [weight, setWeight] = useState('');
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const loadedState = loadState();
    if (loadedState && loadedState.weightHistory) {
      setHistory(loadedState.weightHistory);
    }
  }, []);

  const handleAddWeight = () => {
    if (weight) {
      const newEntry = {
        date: new Date().toISOString().slice(0, 10),
        weight: parseFloat(weight),
      };
      const newHistory = [newEntry, ...history.slice(0, 255)];
      setHistory(newHistory);
      const state = loadState() || {};
      saveState({ ...state, weightHistory: newHistory });
      setWeight('');
    }
  };

  const chartData = {
    labels: history.map(entry => entry.date).reverse(),
    datasets: [
      {
        label: t('weight_kg'),
        data: history.map(entry => entry.weight).reverse(),
        fill: false,
        backgroundColor: 'rgb(248, 191, 207)',
        borderColor: 'rgba(248, 191, 207, 0.2)',
      },
    ],
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ textAlign: 'center', color: '#333' }}>{t('weight_tracker')}</h2>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
        <input
          type="number"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
          placeholder={t('enter_weight')}
          style={{
            padding: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            marginRight: '10px',
            width: '150px',
          }}
        />
        <button
          onClick={handleAddWeight}
          style={{
            padding: '10px 20px',
            borderRadius: '5px',
            border: 'none',
            backgroundColor: '#f8bfcf',
            color: 'white',
            cursor: 'pointer',
          }}
        >
          {t('add_weight')}
        </button>
      </div>
      {history.length > 0 && <Line data={chartData} />}
      <ul style={{ listStyleType: 'none', padding: 0, marginTop: '20px' }}>
        {history.map((entry, index) => (
          <li
            key={index}
            style={{
              backgroundColor: '#fbeff3',
              padding: '10px',
              borderRadius: '5px',
              marginBottom: '10px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <span>{entry.date}</span>
            <span>{entry.weight} kg</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WeightView;
